
import CpntBlocPresentationDetail from "../../components/CpntBlocPresentationDetail";
import { ContactSujetIds } from "../../config/helpers";
import img_alerte_poche_1 from "../../images/presentation/alerte_poche_1.png"
import "./PagePresentation.scss"

const description1 =
<>
  <p>
    L&apos;alerte poche vous permet de rester informé des sorties en format poche de vos ouvrages pour ajuster les prix de vos publications numériques.
    <br></br>
    Chaque mois, nous vous envoyons <b>un rapport détaillé au format CSV</b>, vous fournissant une vue d&apos;ensemble des nouvelles parutions en poche,
    avec toutes les informations essentielles, pour optimiser votre stratégie tarifaire.
    </p>
    <p>
    <b>Déjà adopté par plusieurs éditeurs, alerte poche est un outil indispensable pour simplifier la gestion de votre catalogue.</b>
  </p>
</>
;
const description2 =
<div className="mt-4">
  <p className="text-md-start text-justify fst-italic">
   Je reçois les alertes poche chaque mois et je les compile par période de 3 mois.<br/>
        Je compare ensuite les données de prix entre les fichiers et nos systèmes afin de prévenir les éditeurs si des différences de prix numérique et poche sont à remarquer et à modifier si besoin. Les alertes poche sont ainsi un outil d&apos;aide à la décision pour nous et notre stratégie de prix. 
        <br/>
        <u>Mona, Hachette Livre</u>
        </p>
      <p className="text-md-start text-justify fst-italic">
      L&apos;alerte me permet de savoir à quelle date et à quel prix sortent les livres en poche.
      <br/>
        En effet, quand un livre sort en poche, nous modifions le prix du livre numérique afin d&apos;être proche du prix poche.
        <br/>
        Un livre numérique ne se vendra pas bien si son prix dépasse le prix du poche.
        <br/>
        <u>Marie, Grasset</u>
      </p>
      </div>
;

const PagePresentation_AlertePoche = () => {
   return (
      <>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
            <div className="titre titre-Presentation text-center">Alerte Poche</div>
          </div>
        </div>
        <CpntBlocPresentationDetail
          description1={description1}
        description2={description2}
          img_rond={img_alerte_poche_1}
          linktext="Nous contacter"
          contactsujet={ContactSujetIds.AlertePoche}
        />
        </>
  );
};

export default PagePresentation_AlertePoche;
